import './global.js';
import { v$, compose, listen, scroll } from './includes/helpers';
import { creditsCalculator } from './includes/creditsCalculator';
import { closePopup, openPopup } from './includes/popupForm';
import vanillaTextMask from 'vanilla-text-mask';


//Elements
const dropDownTitle = v$('.drop_down-title'),
  creditsItem = v$('.credits-take-content-item'),
  sumInput = v$('.js-credits_sum')[0],
  termInput = v$('.js-credits_term')[0],
  creditRes = v$('.appliances_result')[0],
  promoCodeLink = v$('.promo-code-text')[0],
  promoPopUp = v$('#promo')[0],
  promoPopUpClose =v$('#promo .popup-close')[0],
  promoCodeWrap = v$('.promo-code-wrap')[0];

if (promoCodeWrap) {
  const setInputPromoType = () => {
    let parentOneDay = document.querySelector('.promo-code-wrap');
    let inputPromoType = document.querySelector('#type');
    inputPromoType.value = parentOneDay.getAttribute('id').replace(/promo-/g, "");
  }
  setInputPromoType();
}
//data
// if (creditsItem) {
  const creditsItemMarginBottom = window
    .getComputedStyle(creditsItem[0])
    .getPropertyValue('margin-bottom');
  const creditsDropMarginBottom = parseInt(
    window
      .getComputedStyle(v$('.drop_down-content')[0])
      .getPropertyValue('margin-bottom')
  );
// }
const calcData =
    process.env.NODE_ENV === 'development'
      ? {
          '0-7': { '0-1500': 0.89, '1500-3000': 0.78, '3000-3000': 2 },
          '15-30': { '0-700': 0.67 }
        }
      : window.creditsCalcData;
//call imported functions
creditsCalculator(calcData, sumInput, termInput, creditRes);
//functions
const closeOther = target => {
  let dropDown = v$('.drop_down-content');
  creditsItem.forEach(
    item => {item.style.marginBottom = creditsItemMarginBottom}
  );
  dropDown.forEach(item => {
    item.classList.remove('open');
  });
  return target;
};
const getTop = target => {
  let itemOffset = target.parentNode.parentNode.offsetTop,
    itemHeight = target.parentNode.parentNode.scrollHeight;
  return {
    target,
    top: `${itemOffset + itemHeight}px`
  };
};
const setTop = ({ target, top }) => {
  target.style.top = top;
  return target;
};
const setParentMargin = target => {
  let marginBottom = `${target.scrollHeight + creditsDropMarginBottom}px`;
  target.parentNode.parentNode.style.marginBottom = marginBottom;
  return target;
};
const toggleClass = target => {
  target.className.includes('open')
    ? target.classList.remove('opne')
    : target.classList.add('open');
};
const toggleDropDown = compose(toggleClass, setParentMargin, setTop, getTop);
listen(dropDownTitle, 'click', e => {
  let toggleTarget = v$('.drop_down-content', e.target.parentNode)[0],
    creditsBlock = v$('.credits-take')[0];
  // closeOther(e.target);
  if (!toggleTarget.className.includes('open')) {
    closeOther(e.target);
    setTimeout(() => {
      toggleDropDown(toggleTarget);
    }, 550);
    // setTimeout(() => {
    //    scroll(creditsBlock.offsetTop, creditsBlock.offsetTop > window.pageXOffset ? 'top' : 'bottom');
    // },700);
  } else {
    closeOther(e.target);
  }
});

if (promoCodeWrap) {
  promoCodeLink.addEventListener('click', (e) => {
    e.preventDefault();
    openPopup(promoPopUp);
  })

  promoPopUpClose.addEventListener('click', (e) => {
    e.preventDefault();
    closePopup(promoPopUp);
  })
}

// let topPos = dropDownTitles.offsetTop;
// console.log(topPos);
